import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const ankenyOptions: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

const ankenyEmergencyDescription =
  "Iowa has ZERO passport agencies — 3.2M residents have absolutely no in-state emergency option. Closest: Chicago ~330 mi (5.5+ hours) or Minneapolis ~250 mi (4+ hours). Ankeny is the fastest-growing Des Moines suburb and home to John Deere's Financial headquarters — ag-tech executives flying to Brazil or India for equipment negotiations cannot afford a 9–11 hour round trip to Chicago's single agency, which also serves Illinois' 12.5M residents. DMACC sends hundreds of students abroad annually — an Ankeny student discovering an expired passport 48 hours before a flight to Barcelona faces an 11-hour round trip through Iowa's I-80 corridor, where winter blizzards routinely shut down the interstate. When I-80 closes due to whiteout conditions between Des Moines and the Illinois border, Ankeny is severed from every passport agency on the North American continent. Zero Iowa agencies. 3.2 million people. Closest help is half a day of driving — weather permitting.";

const ankenyDisclaimer =
  "Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. Iowa residents have no in-state passport agency — the nearest are Chicago, IL and Minneapolis, MN.";

export default function AnkenyProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Ankeny"
      headingExtra="IA"
      introText="Ankeny travelers — John Deere Financial professionals, DMACC students, Des Moines Area Community College faculty, and Prairie Trail families — have several options for getting a passport fast. Here is how they compare, and why most Ankeny and Polk County residents choose a U.S. Department of State registered passport courier for predictable, professional processing."
      options={ankenyOptions}
      emergencyDescription={ankenyEmergencyDescription}
      disclaimerText={ankenyDisclaimer}
    />
  );
}